import { ContInspectores } from "../model/cont_inspectores";
import { ContPermisos } from "../model/cont_permisos";
import { ContSedes } from "../model/cont_sedes";
import { UsuarioResponse } from "./usuario-response";

export class LocalReponse {
    code?: string;
    msg?: string;
    permisos?: ContPermisos;
    severity?: string;
    usuario?: UsuarioResponse;
    inspector?:ContInspectores;
    sede?:any;
}
